<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>

    <b-col cols="12">
      <transition name="slide">
        <b-card header="Lista de produtos cadastrados">
          <b-row>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Produto">
                  <b-form-input
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                    v-model="product"
                    @keyup.enter="getProducts(page)"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!product" @click="cleanSearch()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <pagination :source="pagination" @navigate="navigate"></pagination>
          </b-row>

          <b-table
            id="tableItens"
            hover
            striped
            bordered
            responsive="sm"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="abrirModal"
            head-variant="light"
          >
            <template #thead-top>
              <b-tr>
                <b-th colspan="2">Ativo</b-th>
                <b-th colspan="4">Dados do Item</b-th>
                <b-th colspan="2">Valores</b-th>
                <b-th colspan="3">Subdivisões</b-th>
                <b-th colspan="3">Permissões</b-th>
              </b-tr>
            </template>

            <template v-slot:cell(foto)="data">
              <img
                v-if="data.item.foto"
                width="40"
                height="40"
                class="center-image"
                text-align="center"
                :src="data.item.foto"
                alt="Thumbnail"
              />
            </template>

            <template v-slot:cell(ativo)="data">
              <b-badge v-if="data.item.ativo == false" variant="danger">
                {{ data.item.ativo == false ? "Não" : "Sim" }}
              </b-badge>
              <b-badge v-else variant="success">
                {{ data.item.ativo == false ? "Não" : "Sim" }}
              </b-badge>
            </template>

            <template v-slot:cell(observacoesCadastro)="data">
              <b-badge
                v-if="data.item.observacoesCadastro != ''"
                variant="danger"
              >
                {{ data.item.observacoesCadastro != "" ? "Não" : "Sim" }}
              </b-badge>
              <b-badge v-else variant="success">
                {{ data.item.observacoesCadastro != "" ? "Não" : "Sim" }}
              </b-badge>
            </template>

            <template v-slot:cell(permiteVendaSemEstoque)="data">
              <b-badge
                v-if="data.item.permiteVendaSemEstoque"
                variant="success"
              >
                {{ data.item.permiteVendaSemEstoque ? "Sim" : "Não" }}
              </b-badge>
              <b-badge v-else variant="danger">
                {{ data.item.permiteVendaSemEstoque ? "Sim" : "Não" }}
              </b-badge>
            </template>

            <template v-slot:cell(permiteObs)="data">
              <b-badge v-if="data.item.permiteObs" variant="success">
                {{ data.item.permiteObs ? "Sim" : "Não" }}
              </b-badge>
              <b-badge v-else variant="danger">
                {{ data.item.permiteObs ? "Sim" : "Não" }}
              </b-badge>
            </template>

            <template v-slot:cell(descricaoSetor)="data">
              {{ data.item.setorId }} - {{ data.item.descricaoSetor }}
            </template>

            <template v-slot:cell(descricaoGrupo)="data">
              {{ data.item.grupoId }} - {{ data.item.descricaoGrupo }}
            </template>

            <template v-slot:cell(descricaoMarca)="data">
              {{ data.item.marcaId }} - {{ data.item.descricaoMarca }}
            </template>
          </b-table>
        </b-card>
      </transition>
    </b-col>

    <b-modal ref="modalObsCadastro" title="Dados do Item" size="md">
      <div class="card" style="width: 100%">
        <b-card
          bg-variant="dark"
          text-variant="white"
          title="Foto"
          class="text-center"
          style="height: 60px"
        ></b-card>
        <img
          :src="foto"
          class="card-img-top"
          style="width: 100%; height: 100%"
        />
      </div>
      <div>
        <b-card
          v-if="observacoesCadastro && observacoesCadastro.length > 1"
          bg-variant="dark"
          text-variant="white"
          title="Observações"
          class="text-center"
          style="height: 60px"
        ></b-card>
        <ul v-for="(obs, index) in observacoesCadastro" :key="index">
          <li v-if="obs" class="card-text">
            {{ obs }}
          </li>
        </ul>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
import * as config from "@/config.json";
import { cnpjFormatter } from "../../assets/views/functions";

import Pagination from "../../assets/components/pagination.vue";
import ImageItem from "../banner/ImageItem.vue";

export default {
  name: "ProdutosCadastrados",
  props: ["source"],
  components: { Loading, Pagination, ImageItem },
  data: () => {
    return {
      pagination: {},
      items: [],
      fields: [
        { key: "ativo", label: "Sistema" },
        { key: "observacoesCadastro", label: "App" },
        { key: "foto", label: "Foto" },
        { key: "codBarras", label: "Barras" },
        { key: "descricao", label: "Descrição" },
        { key: "quantidade", label: "Qtde" },
        { key: "quantidadePorcao", label: "Porção" },
        { key: "venda", label: "Venda" },
        { key: "precoFidelizado", label: "Fidelizado" },
        { key: "descricaoSetor", label: "Setor" },
        { key: "descricaoGrupo", label: "Grupo" },
        { key: "descricaoMarca", label: "Marca" },
        { key: "permiteVendaSemEstoque", label: "Venda s/ Estoque" },
        { key: "permiteObs", label: "Obs" },
      ],
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      isLoading: false,
      filterOn: [],
      cnpj: "",
      product: "",
      show: "Todos",
      observacoesCadastro: null,
      urlRequest: "",
      index: null,
      foto: null,
    };
  },

  methods: {
    abrirModal(i) {
      this.foto = i.foto;
      this.observacoesCadastro = i.observacoesCadastro.split("\n");

      if (this.foto) {
        this.$refs.modalObsCadastro.show();
      } else {
        if (this.observacoesCadastro != "") {
          this.$refs.modalObsCadastro.show();
        }
      }
    },
    navigate(page) {
      this.getProducts(page);
    },

    cleanSearch() {
      (this.product = ""), this.getProducts(this.page);
    },

    getProducts(pagina) {
      this.cnpj = cnpjFormatter(localStorage.getItem("cnpj"));
      const url = `${config.default.urlBaseFdv}/product/search`;
      return axios({
        url: url,
        method: "get",
        params: {
          cnpj: this.cnpj,
          product: this.product,
          show: this.show,
          pageSize: this.perPage,
          page: pagina,
        },
        headers: { authorization: `${config.default.authorizationToken}` },
      })
        .then((response) => {
          this.pagination = response.data;
          this.items = response.data.items;
          this.totalRows = response.data.records;
          this.foto = response.data.foto;
        })
        .catch((error) =>
          console.error({
            errorMessage: `[GetProducts] ${error}`,
          })
        );
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.getProducts(1);
    this.isLoading = false;
  },
};
</script>

<style>
</style>